import React from "react";
import Chapters from "../chapters";

const QuestionsWallet = () => {
  return (
    <Chapters
      activeFilter={0}
      title="حافظة الاسئلة"
      addButtonLabel="اضافة حافظة"
      countLabel="عدد الحافظات"
      nameColumnHeader="حافظة الاسئلة"
      isQuestionsWallet
    />
  );
};

export default QuestionsWallet;
